import { Button } from "@mui/joy";
import { Input } from "@mui/joy";
import { FormLabel } from "@mui/joy";
import React from "react";
export default function Hero() {
  return (
    <section className="py-20 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 text-white">
      <div className="container mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            Unlock the Secrets of Your Cosmic Journey
          </h1>
          <p className="text-xl md:text-2xl text-indigo-100">
            Discover personalized astrology and numerology insights to guide
            your path and illuminate your potential.
          </p>
          {/* <div className="flex space-x-4">
            <Button size="lg" variant="secondary">
              Explore Your Stars
            </Button>
            <Button size="lg" variant="outline">
              Learn More
            </Button>
          </div> */}
        </div>
        <div className="bg-white/80 text-black backdrop-blur-lg p-8 rounded-lg shadow-2xl">
          <h2 className="text-2xl font-bold mb-6 text-center">
            Get Your Free Cosmic Profile
          </h2>
          <form className="space-y-4">
            <div>
              <FormLabel htmlFor="fullName">Full Name</FormLabel>
              <Input id="fullName" placeholder="Enter Full Name" required />
            </div>
            <div>
              <FormLabel htmlFor="dob">Date of Birth</FormLabel>
              <Input id="dob" type="date" required />
            </div>
            <div>
              <FormLabel htmlFor="birthTime">Birth Time (if known)</FormLabel>
              <Input id="birthTime" type="time" placeholder="HH:MM" />
            </div>
            <div>
              <FormLabel htmlFor="birthPlace">Birth Place</FormLabel>
              <Input id="birthPlace" placeholder="City, Country" required />
            </div>
            <div>
              <FormLabel htmlFor="email">Email</FormLabel>
              <Input
                id="email"
                type="email"
                placeholder="your@email.com"
                required
              />
            </div>
            <div>
              <FormLabel htmlFor="mobileNumber">Mobile Number</FormLabel>
              <Input
                type="number"
                id="mobileNumber"
                placeholder="Mobile Number"
                required
              />
            </div>
            <Button type="submit" className="w-full">
              Reveal My Cosmic Profile
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
}
